// extracted by mini-css-extract-plugin
export var pillWrapper = "_mz-0";
export var showOverflow = "_mz-1";